import http from '@/services/http'
import entriesList from './generic/entries-list'

export const state = () => ({
  ...entriesList.getState(),
})

export const mutations = {
  ...entriesList.getMutations(),
  setState(state, { id, newState }) {
    state.entries = updateEntry({
      entries: state.entries,
      id,
      data: { state: newState },
    })
  },
  setStartupsOrder(state, { startupsOrder }) {
    const positions = {}
    startupsOrder.forEach((startupId, idx) => {
      positions[startupId] = idx + 1
    })
    state.entries = state.entries.map((e) => {
      const newEntry = { ...e }
      if (positions[e.startup_id]) {
        newEntry.position = positions[e.startup_id]
      }
      return newEntry
    })
  },
}

function updateEntry({ entries, id, data }) {
  return entries.map((e) => {
    if (e.id === id) {
      return { ...e, ...data }
    } else {
      return { ...e }
    }
  })
}

export const actions = {
  ...entriesList.getActions({
    getQueryUrl({ params }) {
      let url = `/investors/${params.investorId}/funnel-startups`
      const querystring = http.paramsToQuerystring(params)
      if (querystring) {
        url += `?${querystring}`
      }
      return url
    },
    queryIsPaginated: false,
  }),

  setState({ commit }, { id, newState }) {
    commit('setState', { id, newState })
  },
  setStartupsOrder({ commit }, { startupsOrder }) {
    commit('setStartupsOrder', { startupsOrder })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
